import { getUserConfig, setUserConfig } from "@/utils/User";

export const getDarkMode = () => {
    const darkmode = getUserConfig("darkmode");
    if (darkmode === 1 || darkmode === "1") {
        return true;
    } else {
        return false;
    }
};

export const setDarkMode = (darkmode) => {
    const isDark = darkmode === 1 || darkmode === "1" || darkmode === true;
    const value = isDark ? 1 : 0;

    setUserConfig("darkmode", value);

    const html = document.documentElement;
    if (html) {
        html.classList.remove("dark", "light");
        html.classList.add(isDark ? "dark" : "light");
    }
};
